/*
 * NERIONA — Option → Dropdown
 * ---------------------------------------------------------------------------
 * Wandelt eine Variantenauswahl, die als Pill-/Radio-Liste gerendert wird, in
 * ein natives <select> um — exakt im gleichen Look wie das bestehende
 * "Diopter"-Dropdown (gleiche Klassen: .nrn-diopter-wrap / .nrn-diopter-dropdown).
 *
 * Greift NUR bei exakt passenden Optionsnamen (siehe DROPDOWN_OPTION_NAMES).
 * "Shoe Size" wird umgewandelt, ein reines "Size" NICHT.
 *
 * Kollisionsschutz: es wird derselbe Marker (dataset.nrnDiopterDone) gesetzt und
 * gelesen wie im Diopter-Skript. Egal welches Skript zuerst läuft — ein
 * Fieldset wird garantiert nur einmal umgebaut.
 */
(function () {
  'use strict';

  /* Erkennung: absichtlich tolerant, aber "Size" allein wird NIE getroffen.
     Trifft z. B. "Shoe Size", "Shoe size (EU)", "US Shoe Size", "Shoe Sizes",
     "Schuhgröße". Trifft NICHT: "Size", "Sizes", "Größe". */
  var EXACT_NAMES = [
    'shoe size', 'shoesize', 'shoe-size',
    'schuhgröße', 'schuhgrösse', 'schuhgroesse', 'schuhgrosse'
  ];

  function norm(s) {
    return (s || '')
      .toString()
      .replace(/\u00a0/g, ' ')   /* geschütztes Leerzeichen */
      .replace(/\s+/g, ' ')
      .replace(/[:\-–—]+$/, '')
      .trim()
      .toLowerCase();
  }

  function isTargetOptionName(text) {
    var n = norm(text);
    if (!n) return false;
    if (EXACT_NAMES.indexOf(n) !== -1) return true;
    if (n.indexOf('schuhgr') !== -1) return true;
    /* "shoe" + "size" in beliebiger Schreibweise/Reihenfolge, mit Zusätzen */
    if (n.indexOf('shoe') !== -1 && n.indexOf('size') !== -1) return true;
    return false;
  }

  /* Sold-out-/Verfügbarkeits-Suffixe aus den Label-Texten entfernen. */
  var STRIP_PATTERNS = [
    /\s*[-–—]\s*sold out.*$/i,
    /\s*[-–—]\s*ausverkauft.*$/i,
    /\s*[-–—]\s*nicht verfügbar.*$/i,
    /\s*[-–—]\s*unavailable.*$/i,
    /\s*\(sold out\)\s*$/i,
    /\s*\(ausverkauft\)\s*$/i,
    /\s*\(nicht verfügbar\)\s*$/i,
    /\s*\(unavailable\)\s*$/i
  ];

  var HIDDEN_TEXT_CLASSES = [
    'visually-hidden',
    'sr-only',
    'a11y-hidden',
    'visuallyhidden',
    'screen-reader-text'
  ];

  /* Label-Text ohne die a11y-Hilfstexte ("Variant sold out or unavailable" o. ä.). */
  function getVisibleLabelText(label) {
    if (!label) return '';
    var clone = label.cloneNode(true);

    HIDDEN_TEXT_CLASSES.forEach(function (cls) {
      clone.querySelectorAll('.' + cls).forEach(function (el) {
        el.remove();
      });
    });

    /* Der aktuell gewählte Wert steht in der Legende ("Shoe Size 42") und
       darf den Namensvergleich nicht verfälschen. */
    clone.querySelectorAll('[data-selected-value], .form__label-value').forEach(function (el) {
      el.remove();
    });

    clone
      .querySelectorAll('[style*="display:none"], [style*="display: none"], [hidden]')
      .forEach(function (el) {
        el.remove();
      });

    return clone.textContent || '';
  }

  function cleanLabelText(raw) {
    var text = (raw || '').trim();
    STRIP_PATTERNS.forEach(function (re) {
      text = text.replace(re, '');
    });
    return text.trim();
  }

  /* Sichtbarer Teil der Legende ohne den aktuell gewählten Wert
     ("Shoe Size: 42" -> "Shoe Size"). */
  function legendName(fieldset) {
    var legend = fieldset.querySelector('legend, .form__label');
    var attr = fieldset.getAttribute('data-option-name') || '';
    if (attr) return attr;
    var raw = legend ? getVisibleLabelText(legend) : '';
    return raw.split('\n')[0].split(':')[0];
  }

  function findTargetFieldsets() {
    var candidates = document.querySelectorAll(
      'variant-selects fieldset, .product-form__input, [data-option-position]'
    );
    var hits = [];

    for (var i = 0; i < candidates.length; i++) {
      var fs = candidates[i];
      if (fs.dataset.nrnDiopterDone === '1') continue;
      if (!fs.querySelector('input[type="radio"]')) continue;
      if (isTargetOptionName(legendName(fs))) hits.push(fs);
    }

    return hits;
  }

  function convertToDropdown(fieldset) {
    if (!fieldset || fieldset.dataset.nrnDiopterDone === '1') return;

    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    if (!inputs.length) return;

    fieldset.dataset.nrnDiopterDone = '1';

    var wrap = document.createElement('div');
    wrap.className = 'nrn-diopter-wrap nrn-option-dropdown-wrap';

    var select = document.createElement('select');
    select.className = 'nrn-diopter-dropdown nrn-option-dropdown';
    select.setAttribute('aria-label', cleanLabelText(legendName(fieldset)) || 'Shoe Size');

    inputs.forEach(function (input) {
      var label = fieldset.querySelector('label[for="' + input.id + '"]');
      var text = cleanLabelText(label ? getVisibleLabelText(label) : input.value);
      if (!text) text = input.value;

      var opt = document.createElement('option');
      opt.value = input.value;
      opt.textContent = text;
      if (input.checked) opt.selected = true;
      if (input.disabled) opt.disabled = true;
      select.appendChild(opt);
    });

    /* Auswahl auf das echte Radio zurückspiegeln, damit die Variantenlogik
       des Themes unverändert weiterläuft. */
    select.addEventListener('change', function (e) {
      /* NRN FIX 1: dieses <select> liegt INNERHALB von <variant-selects>.
         Ohne stopPropagation blubbert das change-Event dorthin hoch,
         VariantSelects nimmt den SELECT-Zweig, sucht `option[selected]`
         (gibt es hier nicht) und wirft einen TypeError. Ausserdem hatten die
         Optionen keine data-option-value-id -> die Section-URL enthielt
         `option_values=undefined` -> Shopify fand keine Variante ->
         setUnavailable() -> Preis wurde ausgeblendet.
         NRN FIX 2: das zusaetzliche input.click() feuerte den Variantenwechsel
         ein zweites Mal; der erste Fetch wurde abgebrochen und der
         Abort-Handler gab die Style-Sperre mitten im Wechsel frei. */
      e.stopPropagation();

      var val = select.value;
      inputs.forEach(function (input) {
        if (input.value === val && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    fieldset
      .querySelectorAll('input[type="radio"], label')
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });

    wrap.appendChild(select);

    var legend = fieldset.querySelector('legend, .form__label');
    if (legend && legend.parentNode === fieldset) {
      legend.insertAdjacentElement('afterend', wrap);
    } else {
      fieldset.insertBefore(wrap, fieldset.firstChild);
    }

    select.style.setProperty('width', 'auto', 'important');
    select.style.setProperty('min-width', '0', 'important');
    select.style.setProperty('max-width', '100%', 'important');
    select.style.setProperty('margin-bottom', '-2px', 'important');
  }

  function run() {
    findTargetFieldsets().forEach(convertToDropdown);
  }

  function boot() {
    run();
    setTimeout(run, 300);
    setTimeout(run, 1000);

    /* Shopify rendert den Variant-Picker bei Variantenwechsel neu —
       deshalb dauerhaft beobachten. convertToDropdown ist idempotent. */
    new MutationObserver(run).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
